var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort-label"},[_vm._l((_vm.list),function(item){return (_vm.list.length > 0)?[_c('router-link',{key:item.id,attrs:{"to":{path:'/sort-ics/'+item.id,query:{tId:item.id,type: item.tyNum+' '+item.tyName}}}},[_vm._v(_vm._s(item.tyNum+' '+item.tyName))])]:_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a49e088","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/sort/SortIcs.vue
// module id = null
// module chunks = 